import { Devi_uploadCompletedData } from './Devi.CompletedData'
import type { Base_Bus } from '../Base/Base.Bus'
import { E2E_deviceSyncComplete } from '../E2E/E2E.dispatch'

export async function Devi_initialise(bus: Base_Bus) {
    // Register handler for device level sync
    bus.registerHandler('device_sync', async () => {
        // Upload completed data
        await Devi_uploadCompletedData()
        E2E_deviceSyncComplete()
    })

    // Start an interval to request device sync every 2 minutes
    const interval = window.setInterval(() => bus.addTask('device_sync', 'Regular device sync'), 1000 * 60 * 2)

    // Disable interval syncing during end to end tests
    window.addEventListener('E2E_StopSyncing', () => clearInterval(interval))
}
